import Fluxible from 'vendor/cnpm/fluxible.v0-4/index';

import ChangeViewSettingsModalStore from 'bundles/in-course-stores/stores/ChangeViewSettingsModalStore';
import NaptimeStore from 'bundles/naptimejs/stores/NaptimeStore';
import ApplicationStore from 'bundles/ssr/stores/ApplicationStore';

import 'css!bundles/global-styles/global-element-styles';

import component from './routes';

export type Stores = {
  ApplicationStore: ApplicationStore;
  NaptimeStore: NaptimeStore;
  ChangeViewSettingsModalStore: ChangeViewSettingsModalStore;
};

function appEnvFactory() {
  const app = new Fluxible({
    component,
  });

  app.registerStore(ApplicationStore);
  app.registerStore(NaptimeStore);
  app.registerStore(ChangeViewSettingsModalStore);

  return app;
}

export default appEnvFactory;
